import { LOCAL_PACKAGE_PREFIXES } from '@cli-constants/deps.js'

export function isLocalPackageSpec(spec: string): boolean {
  return LOCAL_PACKAGE_PREFIXES.some((prefix) => spec.startsWith(prefix))
}
